import EventEmitter from "events";
import { RPCRequests } from "src/modules/communication-protobuf";
const PING_PERIOD = 5 * 1000;
const CHECK_TIMEOUT_PERIOD = 5 * 1000;
const CONNECTION_TIMEOUT_PERIOD = 40 * 1000;

export default class PingService extends EventEmitter {
  constructor({ synchronizeStations }) {
    super();
    this.shouldSynchronizeOnNextPingPong = false;
    this.rpc = null;
    this.peerJid = null;
    this.lastPong = null;
    this.synchronizeStations = synchronizeStations;
  }

  start({ peerJid, rpc }) {
    this.peerJid = peerJid;
    this.rpc = rpc;
    this.lastPong = Date.now();
    this.pingPongIntervalId = setInterval(this.playPingPong, PING_PERIOD);
    this.timeoutCheckerIntervalId = setInterval(
      this.pingPongTimeoutChecker,
      CHECK_TIMEOUT_PERIOD
    );
  }

  stop() {
    clearInterval(this.pingPongIntervalId);
    clearInterval(this.timeoutCheckerIntervalId);
    this.peerJid = null;
    this.rpc = null;
  }

  playPingPong = async () => {
    const request = RPCRequests.Ping.create();
    const shouldSynchronize = this.shouldSynchronizeOnNextPingPong;
    this.shouldSynchronizeOnNextPingPong = false;

    try {
      await this.rpc.call(request, this.peerJid);
      this.lastPong = Date.now();
      this.emit("ping-response", this.peerJid);
      shouldSynchronize && this.synchronizeStations();
    } catch (error) {
      if (shouldSynchronize) this.shouldSynchronizeOnNextPingPong = true;
      this.emit("ping-response-timeout", this.peerJid);
    }
  };

  pingPongTimeoutChecker = () => {
    if (Date.now() > this.lastPong + CONNECTION_TIMEOUT_PERIOD) {
      this.shouldSynchronizeOnNextPingPong = true;
      this.emit("ping-pong-timeout", this.peerJid);
    }
  };
}
